module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-53-min.74b434d7.jpg";